import { useFeatureIsOn } from "@growthbook/growthbook-react";

export const useFeatureFlags = () => {
    return {
        showReviewAnalyticsFeature: useFeatureIsOn("REVSTACK_FEATURE") || false,
        showProductAnalysisFeature: useFeatureIsOn("PRODUCT_ANALYSIS_FEATURE") || false,
        showNewSideBarFeature: useFeatureIsOn("NEW_SIDEBAR_FEATURE") || false,
        showClientsFeature: useFeatureIsOn("CLIENTS_FEATURE") || false,
        showMediaPlanningFeature: useFeatureIsOn("MEDIA_PLANNING_FEATURE") || false,
        showChatbotFeature: useFeatureIsOn("ONEDER_FEATURE") || false,
    };
};
